import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { duplicateAgency } from "../../api/apiAgencies";
import parseError from "../../utils/parseError";

export const useDuplicateAgency = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: duplicateAgency,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            toast.success(data.message || 'Agency duplicated successfully');
        },
        onError: (error) => {
            const errorMessage = parseError(error) || 'Failed to duplicate agency';
            toast.error(errorMessage);
        },
    });
};
